const hotelAttr = "hotelId";
const surnameAttr = "surname";
const CRSNumberAttr = "bookingId";

export { hotelAttr, surnameAttr, CRSNumberAttr };
